import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

export const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100% - 50px)',
    width: '100%',
    backgroundColor: '#EBECF4',
    '& :focus': {
      outline: 'none',
      boxShadow: 'none',
    }
    // overflow: 'auto', IF ANY BUG - UNCOMMENT (COMMENTED AT PR#8854)
  },
  containerFullscreen: {
    height: '100%',
    overflow: 'hidden',
  },
  mainContainer: {
    display: 'flex',
    width: 'calc(100% - 52px)',
    alignItems: 'center',
    height: 'calc(100% - 52px)',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
  },
  mainContainerFullScreen: {
    display: 'flex',
    width: 'calc(100% - 1px)',
    alignItems: 'center',
    height: 'calc(100% - 1px)',
    backgroundColor: '#FFFFFF',
    margin: '10px',
  },
  cardContainer: {
    height: 'calc(100% - 1px)',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    zIndex: 2,
  },
  cardPreview: {
    position: 'relative',
    top: '50px',
    left: '40px',
    height: 'calc(100% - 50px)',
    backgroundColor: 'rgba(219, 220, 229, 0.28)',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: '0.5s ease-in-out',
    overflow: 'auto',
  },
  cardHeader: {
    position: 'absolute',
    left: '1px',
    top: '10px',
    height: '45px',
    width: 'calc(100% - 2px)',
    backgroundColor: '#FFFFFF',
    borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
    alignItems: 'center',
    zIndex: 3,
    transition: '0.5s ease-in-out',
  },
  cardHeaderText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
    marginLeft: '60px',
    marginTop: '-25px',
  },
  backButton: {
    color: '#2C2D3E',
    position: 'relative',
    width: '30px',
    height: '30px',
    background: '#FFFFFF',
    marginLeft: '11px',
    border: '1px solid #2C2D3E',
    borderColor: '#2C2D3E',
    borderRadius: '3px',
    fontSize: 'small',
    '&:hover': {
      cursor: 'pointer',
      background: '#CACAFC80',
    },
  },
  arrowInBackButton: {
    color: '#2C2D3E',
    marginTop: '3px',
    marginLeft: '3px',
  },
  cardSidebar: {
    position: 'absolute',
    left: 'calc(100% - 310px)',
    top: '1px',
    height: 'calc(100% - 2px)',
    width: '307px',
    backgroundColor: '#FFFFFF',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: 3,
    transition: '0.5s ease-in-out',
  },
  card: {
    position: 'absolute',
    display: 'flex',
    border: 'solid 2px rgba(44, 45, 62, 0.3)',
    borderRadius: '4px',
    transition: 'width 0.5s ease-in-out',
  },
  cardThumbnails: {
    position: 'absolute',
    left: 'calc(100% - 290px)',
    top: '100px',
    maxHeight: 'calc(100% - 101px)',
    width: '290px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'auto',
    zIndex: 3,
    transition: '0.5s ease-in-out',
  },
  cardThumbnail: {
    display: 'flex',
    position: 'relative',
    width: '200px',
    border: 'solid 2px rgba(44, 45, 62, 0.3)',
    borderRadius: '4px',
    margin: '10px',
  },
  cardThumbnailActive: {
    border: 'solid 2px #3C419A',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
  },
  cardSidebarMenu: {
    position: 'absolute',
    left: '7px',
    display: 'flex',
    flexDirection: 'row',
    width: '200px',
    padding: '50px 20px 10px 15px',
    transition: '0.5s ease-in-out',
  },
  cardSidebarMenuItem: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: 'rgba(44, 45, 62, 0.5)',
    padding: '20px 20px 20px 0px',
    cursor: 'pointer',
  },
  cardSidebarMenuItemActive: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#2C2D3E',
    padding: '20px 20px 20px 0px',
    cursor: 'pointer',
  },
  cardThumbnailCapition: {
    position: 'relative',
    left: '-115px',
    top: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    color: '#2C2D3E',
  },
  switchIcon: {
    position: 'absolute',
    height: '20px',
    marginTop: '15px',
    color: '#3C419A',
    background: '#ffffff',
    zIndex: 10,
    transition: '0.5s ease-in-out',
    cursor: 'pointer',
  },
  cardDetails: {
    position: 'absolute',
    left: 'calc(100% - 290px)',
    top: '125px',
    width: '285px',
    backgroundColor: '#FFFFFF',
    listStyle: 'none',
    margin: '0px',
    padding: '0px',
    '& li': {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '13px',
      zIndex: 3,
      color: '#000000',
      padding: '8px',
    },
  },
  cardDetail: {
    position: 'absolute',
    left: '130px',
    fontWeight: 700,
  },
  pullRightContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  schoolCode: {
    minWidth: 'fit-content',
  },
  commentsContainer: {
    display: 'flex',
    width: '100%',
    borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
    '& .MuiList-padding': {
      paddingBottom: '0',
      paddingTop: '6px',
    },
  },
}));

export const CancelButton = withStyles(() => ({
  root: {
    width: '103px',
    padding: '0px 0px 0px 0px',
    height: '42px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    marginLeft: '104px',
    marginBottom: '35px',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(Button);

export const ConfirmButton = withStyles(() => ({
  root: {
    position: 'relative',
    marginBottom: '10px',
    marginLeft: '15px',
    marginRight: '104px',
    width: '73px',
    padding: '0px 0px 0px 0px',
    height: '42px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
    },
  },
}))(Button);
